export default __webpack_public_path__ + "static/media/stoly4.4e21dd81.jpg";